import styled from 'styled-components';
import { IonList } from '@ionic/react';

export const IonListWrapper = styled(IonList)`
  .text-spinner {
    height: 20px;
  }
`;
